module.exports = __webpack_public_path__ + "static/media/sup_saf_pas.7f2fa4e4.png";